import React from 'react';

import {
  history,
} from 'web-history';

import {
  Flex,
} from 'web-styled';

import {
  Pagination,
} from 'web-components';

import Video from './Video';
import * as S from './styled';

type Props = {
  order: string,
  videos: any[],
  pageMeta?: {
    page: number,
    total_pages: number,
  },
  itemWidth?: string,
  itemHeight?: string,
  readOnly?: boolean,
  onRemove: { (): void },
  onChangeName?: { (videoId: number, newName: string): void },
};

const ManageVideos = ({
  order,
  videos,
  pageMeta,
  readOnly,
  itemWidth,
  itemHeight,
  onRemove,
  onChangeName,
}: Props) => (videos.length ? (
  <Flex
    column
    align="center"
    width="100%"
  >
    <Flex
      wrap="wrap"
      width="100%"
      spacing={15}
    >
      {videos.map(video => (
        <Flex
          key={video.id}
          width={itemWidth}
          height={itemHeight}
          margin="0 0 15px 0"
        >
          <Video
            video={video}
            readOnly={readOnly}
            onRemove={onRemove}
            onChangeName={onChangeName}
          />
        </Flex>
      ))}
    </Flex>

    {pageMeta?.total_pages && pageMeta?.total_pages > 1 && (
      <Pagination
        count={pageMeta.total_pages}
        current={pageMeta.page}
        goToPage={(page) => {
          history.push(`/videos/${order}/${page}`);
        }}
      />
    )}
  </Flex>
) : (
  <S.EmptyVideos>
    Nothing to show
  </S.EmptyVideos>
));

ManageVideos.defaultProps = {
  itemWidth: '256px',
  itemHeight: '300px',
  pageMeta: null,
  readOnly: true,
  onChangeName: null,
};

export default ManageVideos;
